import { getUserGeoCoordinates, getNearestCityByCoordinates, isDefined, LocationTypeEnum } from "@perxis-auto/shared/lib";
import { FilterLocationEnum } from "../../../features/filterValues/types/values.js";
async function getUserLocation(locations) {
  const cities = locations.filter((location) => location.type !== FilterLocationEnum.Cluster);
  if (!cities.length) {
    return;
  }
  const coordinates = await getUserGeoCoordinates();
  if (!coordinates) {
    return;
  }
  const nearestCity = getNearestCityByCoordinates(cities, coordinates);
  if (!nearestCity) {
    return;
  }
  const nearestCluster = locations.find(
    (location) => {
      var _a;
      return location.type === FilterLocationEnum.Cluster && location.id === ((_a = nearestCity.cluster) == null ? void 0 : _a.id);
    }
  );
  const isValidCluster = isDefined(nearestCluster == null ? void 0 : nearestCluster.id) && isDefined(nearestCluster == null ? void 0 : nearestCluster.name);
  if (isValidCluster) {
    return {
      id: nearestCluster.id,
      name: nearestCluster.displayName,
      type: LocationTypeEnum.Cluster
    };
  }
  return {
    id: nearestCity.id,
    name: nearestCity.displayName,
    type: LocationTypeEnum.City
  };
}
export {
  getUserLocation
};
